<template>
<div class="chapter">
<div class="inner_page">
<p class="fm_title"><a id="page_vii">Contents</a></p><a id="page_vii">
<table cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="toca"><a href="#/08ack"><i>Acknowledgments</i></a></p></td>
<td valign="bottom"><p class="toc"><a href="#/08ack">ix</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><a href="#/10intr">INTRODUCTION</a></p></td>
<td valign="bottom"><p class="toc"><a href="#/10intr">1</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><a href="#/11ch1"><span class="small">CHAPTER ONE</span><br/>Lies and the Murderer Next Door</a></p></td>
<td valign="bottom"><p class="toc"><a href="#/11ch1">5</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/12ch2" title="Link target outside of Sample"><span class="small">CHAPTER TWO</span><br/>Duress and Moral Progress</span></p></td>
<td valign="bottom"><p class="toc"><span href="#/12ch2" title="Link target outside of Sample">47</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/13ch3" title="Link target outside of Sample"><span class="small">CHAPTER THREE</span><br/>A Thinker-Based Approach to Freedom of Speech</span></p></td>
<td valign="bottom"><p class="toc"><span href="#/13ch3" title="Link target outside of Sample">79</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/14ch4" title="Link target outside of Sample"><span class="small">CHAPTER FOUR</span><br/>Lying and Freedom of Speech</span></p></td>
<td valign="bottom"><p class="toc"><span href="#/14ch4" title="Link target outside of Sample">116</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/15ch5" title="Link target outside of Sample"><span class="small">CHAPTER FIVE</span><br/>Accommodation, Equality, and the Liar</span></p></td>
<td valign="bottom"><p class="toc"><span href="#/15ch5" title="Link target outside of Sample">157</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/16ch6" title="Link target outside of Sample"><span class="small">CHAPTER SIX</span><br/>Sincerity and Institutional Values</span></p></td>
<td valign="bottom"><p class="toc"><span href="#/16ch6" title="Link target outside of Sample">182</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/17ind" title="Link target outside of Sample"><i>Index</i></span></p></td>
<td valign="bottom"><p class="toc"><span href="#/17ind" title="Link target outside of Sample">225</span></p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07cont.vue?4e973550